import { createStore } from '@stencil/store';
// Read more about how stencil stores work here: https://stenciljs.com/docs/stencil-store

const { state, onChange } = createStore({
  i18n: {
    maxweightlabel: '',
    weightlabel: '',
    maxmeasurementlabel: '',
    sizeheading: '',
    senddirectcta: '',
    stampshopcta: '',
  },
  market: {
    currency: '',
  },
});

export { state, onChange };
export default state;
